/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { MdOutlineSwapHoriz, MdOutlineSwapVert } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAsyncSelect from '../../../shared/components/app-async-select/AppAsyncSelect';
import { debounce } from '../../../api/apiUtils';
import { getCitiesApi } from '../../../api/busApi';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import {
  formatDate,
  getNewDate,
  isMobileWidth,
  serialize,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import { useAppContext } from '../../../saas/AppConfigWrapper';

const DEBOUNCE_DELAY = 500;

export function locationOptions(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'location-focused' : ''} location-option`}
      key={props.value}
    >
      <div className="d-flex">
        <div className="d-flex flex-column location-option__other">
          <span className="location-option__other_location">{props.label}</span>
        </div>
      </div>
    </div>
  );
}

function BusLandingPage() {
  const { appConfig } = useAppContext();
  const getLabel = (location) => {
    return isMobileWidth() ? (
      <div className="fs-14 fw-600">{location}</div>
    ) : (
      <div className="d-flex flex-column mt-1">
        <span style={{ fontSize: '20px', fontWeight: '600', color: '#1E1E1E' }}>
          {location}
        </span>
        <span style={{ fontSize: '12px', fontWeight: '400', color: '5B5B5B' }}>
          All Bus Stops
        </span>
      </div>
    );
  };

  const navigate = useNavigate();
  const originRef = useRef({
    googleplaceid: '',
    label: '',
    location_lat: '',
    location_lon: '',
    locationcode: '3',
    locationname: '',
    locationtype: '',
    state: '',
    value: '3',
  });
  const destinationRef = useRef({
    googleplaceid: '',
    label: '',
    location_lat: '',
    location_lon: '',
    locationcode: '7',
    locationname: '',
    locationtype: '',
    state: '',
    value: '7',
  });
  const [errors, setErrors] = useState({});

  const [search, setSearch] = useState({
    origin: {
      placeid: '3',
      place_type: 'bus',
      place_name: 'Hyderabad (Telangana)',
    },
    destination: {
      placeid: '7',
      place_type: 'bus',
      place_name: 'Bangalore (Karnataka)',
    },
    jdate: getNewDate(TODAY_DATE),
    agentid: '',
    currency: appConfig?.appCurrency,
    numadults: 1,
    numchildren: 0,
    numinfants: 0,
  });

  const handleUpdateSearchState = (name, value) => {
    if (name === 'origin') {
      setSearch((prevState) => ({
        ...prevState,
        origin: {
          ...prevState.origin,
          placeid: value.originValue,
          place_name: value.originlabel,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        origin: undefined,
      }));
    } else if (name === 'destination') {
      setSearch((prevState) => ({
        ...prevState,
        destination: {
          ...prevState.destination,
          placeid: value.destinationValue,
          place_name: value.destinationlabel,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        destination: undefined,
      }));
    } else {
      setSearch((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prev) => ({
        ...prev,
        jdate: undefined,
      }));
    }
  };

  const loadLocationSuggestions = debounce(async (query, callback) => {
    let cities = [];
    if (query.length >= 3) {
      const response = await getCitiesApi(query);
      response.sort((a, b) => a.locationname.length - b.locationname.length);
      cities = response.map((cityNode) => ({
        label: getLabel(cityNode.locationname),
        value: cityNode.locationcode,
        ...cityNode,
      }));
    }
    callback(cities);
  }, DEBOUNCE_DELAY);

  const handleCitySelect = (city, name) => {
    if (name === 'origin') {
      originRef.current = city;
      let originValue = '';
      let originlabel = '';
      if (city !== null) {
        originValue = city.value;
        originlabel = city.locationname;
      }

      handleUpdateSearchState(name, { originValue, originlabel });
    } else {
      destinationRef.current = city;
      let destinationValue = '';
      let destinationlabel = '';
      if (city !== null) {
        destinationValue = city.value;
        destinationlabel = city.locationname;
      }
      handleUpdateSearchState(name, { destinationValue, destinationlabel });
    }
  };
  const handleDateChange = (date, fieldName) => {
    handleUpdateSearchState(fieldName, date);
  };

  const handleBusSearch = () => {
    const errorsObj = {};
    if (search.origin.placeid === '') {
      errorsObj.origin = 'Please select origin.';
    }
    if (search.destination.placeid === '') {
      errorsObj.destination = 'Please select destination.';
    }
    if (
      search.origin.placeid &&
      search.destination.placeid &&
      search.origin.placeid === search.destination.placeid
    ) {
      errorsObj.destination = "Origin, Destination can't be same";
    }
    if (
      search.jdate === null ||
      search.jdate === undefined ||
      search.jdate === ''
    ) {
      errorsObj.jdate = 'Select journey date.';
    }

    setErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0) {
      return true;
    }
    const searchRequest = { ...search };
    searchRequest.jdate = formatDate(searchRequest.jdate, API_DATE_FORMAT);
    const queryParam = serialize(searchRequest);
    navigate(`${NAVIGATION_ROUTES.BUS.BUS_SEARCH}?${queryParam}`);
  };

  const handlePlatformSwap = () => {
    const destinationValue = search.origin.placeid;
    const destinationlabel = search.origin.place_name;
    const originValue = search.destination.placeid;
    const originlabel = search.destination.place_name;
    const tempOriginRef = originRef.current;
    handleUpdateSearchState('origin', { originValue, originlabel });
    handleUpdateSearchState('destination', {
      destinationValue,
      destinationlabel,
    });
    originRef.current = destinationRef.current;
    destinationRef.current = tempOriginRef;
  };
  return (
    <div className="flight-landing-page">
      <div className="flight-landing-page_container">
        <div className="flight-landing-page_search">
          <div className="flight-landing-page_search_container">
            {!isMobileWidth() ? (
              <Row className="flight-landng-page_search_request">
                <Col lg={4} md={4} sm={4} xs={6} className="position-relative">
                  <AppAsyncSelect
                    name="origin"
                    placeholder="Origin"
                    label="Depart From"
                    components={{ Option: locationOptions }}
                    selectedValue={originRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    menuWidth="320px !important"
                    onSelect={handleCitySelect}
                    height={isMobileWidth() ? '54px' : undefined}
                    padding={isMobileWidth() ? '8px 14px' : undefined}
                  />
                  <small className="validation-error">
                    {errors.origin && errors.origin}
                  </small>
                  <div className="d-flex justify-content-center origin-swap">
                    <button
                      onClick={handlePlatformSwap}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <MdOutlineSwapHoriz
                        style={{ color: appConfig?.clientPrimaryColor }}
                      />
                    </button>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={6}>
                  <AppAsyncSelect
                    name="destination"
                    placeholder=""
                    label="Going To"
                    components={{ Option: locationOptions }}
                    selectedValue={destinationRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    menuWidth="320px !important"
                    onSelect={handleCitySelect}
                    height={isMobileWidth() ? '54px' : undefined}
                    padding={isMobileWidth() ? '8px 14px' : undefined}
                    menuStartFromRight={isMobileWidth()}
                  />
                  <small className="validation-error">
                    {errors.destination && errors.destination}
                  </small>
                </Col>
                <Col lg={4} md={4} sm={4} xs={12} className="my-sm-0 my-2">
                  <AppDatePicker
                    className="bust-journey-date-input"
                    customClassName="app-landing-datepicker"
                    labelClassName="landing-datepicker-label"
                    label="Depart Date"
                    dateFormat="dd MMM yy"
                    minDate={getNewDate(TODAY_DATE)}
                    monthsShown={isMobileWidth() ? 12 : 2}
                    selectedDate={search.jdate}
                    onChange={(date) => handleDateChange(date, 'jdate')}
                    showDay
                    valueClassName="fs-14 fw-600"
                  />
                  <small className="validation-error">
                    {errors.jdate && errors.jdate}
                  </small>
                </Col>
              </Row>
            ) : (
              <Row className="flight-landng-page_search_request">
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="position-relative border-bottom-2"
                >
                  <AppAsyncSelect
                    name="origin"
                    placeholder="Origin"
                    label="Depart From"
                    components={{ Option: locationOptions }}
                    selectedValue={originRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    menuWidth="320px !important"
                    onSelect={handleCitySelect}
                    height={isMobileWidth() ? '54px' : undefined}
                    padding={isMobileWidth() ? '8px 14px' : undefined}
                    selectedTab="bus"
                  />
                  <small className="validation-error">
                    {errors.origin && errors.origin}
                  </small>
                </Col>
                <div
                  className="d-flex justify-content-center origin-swap"
                  style={{ top: '59px' }}
                >
                  <button onClick={handlePlatformSwap}>
                    <MdOutlineSwapVert
                      style={{ color: '#ed5121', marginBottom: '3px' }}
                    />
                  </button>
                </div>
                <Col lg={4} md={4} sm={4} xs={12} className="border-bottom-2">
                  <AppAsyncSelect
                    name="destination"
                    placeholder=""
                    label="Going To"
                    components={{ Option: locationOptions }}
                    selectedValue={destinationRef.current}
                    loadOptionsFn={loadLocationSuggestions}
                    menuWidth="320px !important"
                    onSelect={handleCitySelect}
                    height={isMobileWidth() ? '54px' : undefined}
                    padding={isMobileWidth() ? '8px 14px' : undefined}
                    menuStartFromRight={isMobileWidth()}
                    selectedTab="bus"
                  />
                  <small className="validation-error">
                    {errors.destination && errors.destination}
                  </small>
                </Col>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="my-sm-0 my-2 border-bottom-2"
                >
                  <AppDatePicker
                    className="bust-journey-date-input"
                    customClassName="app-landing-datepicker"
                    labelClassName="landing-datepicker-label"
                    label="Depart Date"
                    dateFormat="dd MMM yy"
                    minDate={getNewDate(TODAY_DATE)}
                    monthsShown={isMobileWidth() ? 12 : 2}
                    selectedDate={search.jdate}
                    onChange={(date) => handleDateChange(date, 'jdate')}
                    showDay
                    valueClassName="fs-14 fw-600"
                  />
                  <small className="validation-error">
                    {errors.jdate && errors.jdate}
                  </small>
                </Col>
              </Row>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center service-search-btn">
          <AppButton
            btnText="Search Buses"
            variant="primary"
            onClick={handleBusSearch}
          />
        </div>
      </div>
    </div>
  );
}

export default BusLandingPage;
